<template>
  <div v-loading="loading" class="moment-form-page">
    <!-- 基础信息 -->
    <el-card shadow="never" class="form-card">
      <div slot="header" class="card-header">
        <i class="el-icon-document card-header__icon" />
        <span class="card-header__text">企微消息</span>
      </div>
      <el-form
        ref="baseForm"
        :model="formModel"
        label-width="100px"
        label-position="right"
        class="base-form"
      >
        <el-form-item label="标题" required>
          <el-input
            v-model.trim="title"
            placeholder="请输入标题"
            maxlength="100"
            show-word-limit
            clearable
            class="form-input--wide"
          />
        </el-form-item>
        <el-form-item label="内容" :required="rand_title === 1">
          <el-input
            v-model="content"
            type="textarea"
            :rows="8"
            placeholder="请输入消息文本内容"
            maxlength="2000"
            show-word-limit
            class="form-input--wide"
            @blur="contneer"
          />
        </el-form-item>
        <el-form-item label="随机内容">
          <el-radio-group v-model="rand_title" size="small" @change="changewrrr">
            <el-radio-button :label="1">随机</el-radio-button>
            <el-radio-button :label="0">不随机</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="title_options.length !== 0 && rand_title == 1" label="替换内容">
          <div class="title-options-list">
            <div v-for="(itemq, indexq) in title_options" :key="indexq" class="title-options-item">
              <el-input
                v-model.trim="title_options[indexq]"
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                class="form-input--wide"
              />
              <el-button type="danger" size="mini" plain icon="el-icon-delete" @click="deater(indexq)">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="发送类型" required>
          <el-radio-group v-model="push_method" size="small" @change="sendcahaer">
            <el-radio-button :label="1" :disabled="type === 2">官方接口</el-radio-button>
            <el-radio-button :label="2" :disabled="type === 2">第三方接口</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 附件管理 -->
    <el-card shadow="never" class="form-card attachment-card">
      <div slot="header" class="card-header card-header--between">
        <div class="card-header__group">
          <i class="el-icon-paperclip card-header__icon" />
          <span class="card-header__text">附件管理</span>
          <el-tag size="mini" type="info" class="card-header__tag">{{ attachments.length }} / 9</el-tag>
        </div>
        <el-button
          v-if="attachments.length < 9"
          style="margin-left: 15px;"
          type="primary"
          size="small"
          icon="el-icon-plus"
          plain
          @click="add"
        >添加附件</el-button>
      </div>

      <div v-if="attachments.length !== 0" class="attachment-tip">
        <i class="el-icon-info" />
        <span>最多支持 9 个附件，图片、图文、小程序类型按需选择。</span>
        <span>内容与附件不能同时为空</span>
        <span>按住附件卡片拖动可调整顺序，保存后生效</span>
      </div>

      <div v-if="attachments.length === 0" class="attachment-empty">
        <i class="el-icon-folder-opened attachment-empty__icon" />
        <p class="attachment-empty__text">暂无附件，可点击上方按钮添加</p>
        <p class="attachment-empty__hint">内容与附件不能同时为空</p>
      </div>

      <draggable
        v-else
        ref="attachmentList"
        v-model="attachments"
        class="attachment-list"
        draggable=".attachment-item"
        filter="button, a, input, textarea, select, label, .el-radio-group, [contenteditable]"
        :prevent-on-filter="false"
        ghost-class="attachment-item--ghost"
        chosen-class="attachment-item--chosen"
        :animation="150"
        :disabled="attachmentSortDisabled"
        :scroll-sensitivity="60"
        :scroll-speed="10"
      >
        <div
          v-for="(item, index) in attachments"
          :key="attachmentKey(item)"
          class="attachment-item"
        >
          <div class="attachment-item__header">
            <span class="attachment-item__drag-handle" title="拖动调整附件顺序">
              <span class="attachment-item__index">附件 {{ index + 1 }}</span>
            </span>
            <el-radio-group
              v-model="item.msgtype"
              size="small"
              @change="dialogtype(item.msgtype, index)"
            >
              <el-radio-button label="image">图片</el-radio-button>
              <el-radio-button label="link">图文</el-radio-button>
              <el-radio-button label="miniprogram" :disabled="push_method != 1">官方小程序</el-radio-button>
              <el-radio-button label="sp_miniprogram" :disabled="push_method === 1">第三方小程序</el-radio-button>
            </el-radio-group>
            <div class="attachment-item__actions">
              <el-button
                type="primary"
                size="mini"
                plain
                icon="el-icon-edit-outline"
                @click="dialogtyper(item.msgtype, index)"
              >编辑</el-button>
              <el-button
                type="danger"
                size="mini"
                plain
                icon="el-icon-delete"
                @click="deleter(index)"
              >删除</el-button>
            </div>
            <span class="attachment-item__drag-handle attachment-item__drag-hint">
              <i class="el-icon-rank" aria-hidden="true" />
              <span>长按拖动顺序</span>
            </span>
          </div>

          <div class="attachment-item__body">
            <!-- 图片预览 -->
            <template v-if="item.msgtype === 'image'">
              <div
                v-if="item.image && item.image.source_material_id !== '' && item.image.source_material_id !== null"
                class="image-preview"
                @click="dialogtyper(item.msgtype, index)"
              >
                <img :src="item.image.pic_url" alt="附件图片">
                <div class="image-preview__mask">
                  <i class="el-icon-edit" />
                  <span>点击更换</span>
                </div>
              </div>
              <div
                v-else
                class="image-uploader"
                @click="dialogtyper(item.msgtype, index)"
              >
                <i class="el-icon-plus image-uploader__icon" />
                <span class="image-uploader__text">选择图片</span>
              </div>
            </template>

            <!-- 图文预览 -->
            <template v-if="item.msgtype === 'link'">
              <div v-if="item.link && item.link.title !== '' && item.link.title !== null" class="link-section">
                <div
                  class="link-preview"
                  @click="dialogtyper(item.msgtype, index)"
                >
                  <div class="link-preview__title">{{ item.link.title }}</div>
                  <div class="link-preview__content">
                    <div class="link-preview__desc">{{ item.link.desc }}</div>
                    <img
                      v-if="linkCoverUrl(item.link)"
                      class="link-preview__thumb"
                      :src="linkCoverUrl(item.link)"
                      alt=""
                    >
                  </div>
                  <div v-if="linkCoverCount(item.link) > 1" class="link-preview__cover-count">共 {{ linkCoverCount(item.link) }} 张封面</div>
                </div>
                <div v-if="item.link.title_options && item.link.title_options.length !== 0" class="link-random-tags">
                  <span class="link-random-tags__label">随机标题：</span>
                  <el-tag v-for="(itemr, indexr) in item.link.title_options" :key="indexr" size="mini" class="link-random-tags__tag">{{ itemr }}</el-tag>
                </div>
                <div v-if="item.link.desc_options && item.link.desc_options.length !== 0" class="link-random-tags">
                  <span class="link-random-tags__label">随机描述：</span>
                  <el-tag v-for="(itemrr, indexrr) in item.link.desc_options" :key="indexrr" size="mini" type="info" class="link-random-tags__tag">{{ itemrr }}</el-tag>
                </div>
              </div>
              <div
                v-else
                class="link-placeholder"
                @click="dialogtyper(item.msgtype, index)"
              >
                <i class="el-icon-link" />
                <span>点击配置图文内容</span>
              </div>
            </template>

            <!-- 官方小程序预览 -->
            <template v-if="item.msgtype === 'miniprogram'">
              <div
                v-if="item.miniprogram && item.miniprogram.title !== '' && item.miniprogram.title !== null"
                class="mincard"
                @click="dialogtyper(item.msgtype, index)"
              >
                <div class="mincard__header">
                  <img
                    v-if="item.miniprogram.weappiconurl"
                    :src="item.miniprogram.weappiconurl"
                    class="mincard__icon"
                    alt=""
                  >
                  <img
                    v-else
                    src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
                    class="mincard__icon"
                    alt=""
                  >
                  <span class="mincard__desc">{{ item.miniprogram.des_1 }}</span>
                </div>
                <div class="mincard__title">{{ item.miniprogram.title }}</div>
                <div class="mincard__type">{{ find(item.miniprogram.app_id) }}</div>
                <img
                  v-if="item.miniprogram.thumburl"
                  :src="item.miniprogram.thumburl"
                  class="mincard__thumb"
                  alt=""
                >
                <div class="mincard__footer">
                  <el-tag size="mini">{{ item.miniprogram.miniprogram_no }}</el-tag>
                </div>
              </div>
              <div
                v-else
                class="link-placeholder"
                @click="dialogtyper(item.msgtype, index)"
              >
                <i class="el-icon-mobile-phone" />
                <span>点击选择官方小程序</span>
              </div>
            </template>

            <!-- 第三方小程序预览 -->
            <template v-if="item.msgtype === 'sp_miniprogram'">
              <div
                v-if="item.sp_miniprogram && item.sp_miniprogram.title !== '' && item.sp_miniprogram.title !== null"
                class="mincard"
                @click="dialogtyper(item.msgtype, index)"
              >
                <div class="mincard__header">
                  <img
                    v-if="item.sp_miniprogram.weappiconurl"
                    :src="item.sp_miniprogram.weappiconurl"
                    class="mincard__icon"
                    alt=""
                  >
                  <img
                    v-else
                    src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
                    class="mincard__icon"
                    alt=""
                  >
                  <span class="mincard__desc">{{ item.sp_miniprogram.des_1 }}</span>
                </div>
                <div class="mincard__title">{{ item.sp_miniprogram.title }}</div>
                <img
                  v-if="item.sp_miniprogram.thumburl"
                  :src="item.sp_miniprogram.thumburl"
                  class="mincard__thumb"
                  alt=""
                >
                <div class="mincard__footer">
                  <el-tag size="mini">{{ item.sp_miniprogram.miniprogram_no }}</el-tag>
                </div>
              </div>
              <div
                v-else
                class="link-placeholder"
                @click="dialogtyper(item.msgtype, index)"
              >
                <i class="el-icon-mobile-phone" />
                <span>点击选择第三方小程序</span>
              </div>
            </template>

            <div v-if="!item.msgtype" class="type-placeholder">
              <i class="el-icon-warning-outline" />
              <span>请先选择附件类型</span>
            </div>
          </div>
        </div>
      </draggable>
    </el-card>

    <!-- 底部操作 -->
    <el-card shadow="never" class="form-card form-card--actions">
      <div class="form-actions">
        <el-button @click="goBack">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="onclick">确定</el-button>
      </div>
    </el-card>

    <!-- 上传图片弹窗 -->
    <el-dialog title="图片库" :visible.sync="dialogVisibletwo" :close-on-click-modal="false" width="720px" append-to-body>
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
    <!-- 图文弹窗 -->
    <el-dialog title="选择图文" :visible.sync="dialogVisibletu" :close-on-click-modal="false" width="800px" append-to-body :destroy-on-close="true">
      <edittuwen ref="tuwenview" multiple-covers @callback="callback" />
    </el-dialog>
    <!-- 官方小程序弹窗 -->
    <el-dialog title="选择官方小程序" :visible.sync="dialogVisiblewechat" :close-on-click-modal="false" width="70%" append-to-body :destroy-on-close="true">
      <wecaht ref="wecahtview" @callwechat="callwechat" />
    </el-dialog>
    <!-- 第三方小程序弹窗 -->
    <el-dialog title="选择第三方小程序" :visible.sync="dialogVisiblewecaht" width="70%" append-to-body :close-on-click-modal="false" :destroy-on-close="true">
      <wechat ref="wechatview" @wechatcallback="wechatcallback" />
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import chooseimg from '../menumanagement/components/TencentCloudChooseimg.vue'
// import chooseimg from '../menumanagement/components/chooseimg.vue'
import { spMessage, spMessagelistupdata, sprEnterprise, getMultiTitles } from '@/api/officialaccount.js'
import { mptypeslist } from '@/api/sourceMaterial.js'
import edittuwen from './components/edittuwen.vue'
import { getRandomTextOptions } from '@/utils/randomTextOptions'
import { getLinkCovers, getLinkCoverFields, getLinkCoverUrl, isCompleteLinkCover } from '@/utils/linkCovers'
// import wecaht from './components/wecaht.vue'
import wecaht from './components/wechat------.vue'
import wechat from '../enterpriseAstaff/components/wechat.vue'

const attachmentKeys = new WeakMap()
let nextAttachmentKey = 0

export default {
  components: { draggable, chooseimg, edittuwen, wecaht, wechat },
  data() {
    return {
      radio: '',
      content: '', // 内容
      content0: '',
      title: '', // 标题
      rand_title: 0,
      title_options: [],
      attachments: [
        // { // 数据数组
        // msgtype: ''
        // image: {
        //   source_material_id: '',
        //   pic_url: ''
        // }
        //   "link": {
        // 	"title": "消息标题",
        // 	"picurl": "https://example.pic.com/path",
        // 	"desc": "消息描述",
        // 	"url": "https://example.link.com/path"
        // }
        // }
      ],
      dialogVisibletwo: false, // 图片库弹窗
      dialogVisibletu: false, // 图文的弹窗
      dialogVisiblewechat: false, // 小程序的弹窗
      activetype: '', // 类型
      activeindex: null, // 选择的索引
      type: null, // 新增还是编辑类型
      sp_message_no: null, // 编辑的id
      programtype: [], // 小程序类型
      attachmentsarrs: [], // 数据数组(要传的)
      ids: null,
      loading: false,
      submitting: false,
      dialogVisiblewecaht: false,
      push_method: 1,
      tihuan: [{ value: '111' }, { value: '222' }],
      show: false,
      newContent: [],
      messageload: false
    }
  },
  computed: {
    attachmentSortDisabled() {
      return this.loading || this.submitting || this.dialogVisibletwo ||
        this.dialogVisibletu || this.dialogVisiblewechat || this.dialogVisiblewecaht
    },
    formModel() {
      return {
        title: this.title,
        content: this.content,
        rand_title: this.rand_title,
        push_method: this.push_method
      }
    }
  },
  created() {
    const res = window.JSON.parse(window.localStorage.getItem('massageStorage') || '{}')
    // eslint-disable-next-line eqeqeq
    if (this.$route.query.type == 1) {
      if (Object.keys(res).length !== 0) {
        console.log(11111112222, res)
        this.title = res.title
        this.content = res.content
        this.rand_title = res.rand_title
        this.title_options = res.title_options
        // this.attachmentsarrs = res.attachmentsarrs
        this.attachments = res.attachments
        this.push_method = res.push_method
        this.sp_message_no = res.sp_message_no
      }
    }

    this.getmptypeslist()
    this.type = this.$route.query.type
    console.log(this.$route.query.type)
    // eslint-disable-next-line eqeqeq
    if (this.$route.query.type == 1) {
      console.log('新增')
    } else {
      this.ids = this.$route.query.sp_message_no
      this.detail()
    }
  },
  mounted() {},
  beforeDestroy() {
    // eslint-disable-next-line eqeqeq
    if (this.type == 1) {
      if (!this.messageload) {
        const data = {
          title: this.title,
          content: this.content,
          rand_title: this.rand_title,
          title_options: this.title_options,
          // attachmentsarrs: this.attachmentsarrs,
          attachments: this.attachments,
          push_method: this.push_method,
          sp_message_no: this.sp_message_no
        }
        window.localStorage.setItem('massageStorage', JSON.stringify(data))
      } else {
        window.localStorage.removeItem('massageStorage')
      }
    }
  },
  methods: {
    linkCoverUrl: getLinkCoverUrl,
    linkCoverCount(link) {
      return getLinkCovers(link).length
    },
    attachmentKey(item) {
      if (!attachmentKeys.has(item)) {
        attachmentKeys.set(item, ++nextAttachmentKey)
      }
      return attachmentKeys.get(item)
    },
    goBack() {
      this.$router.go(-1)
    },
    dialogtype(type, index) {
      if (type === 'image') {
        if (this.attachments[index].image) {
          console.log('有image')
        } else {
          this.attachments[index].image = {}
          this.attachments[index].image.source_material_id = ''
          this.attachments[index].image.pic_url = ''
          // delete this.attachments[index].link
          // delete this.attachments[index].miniprogram
        }
      } else if (type === 'link') {
        if (this.attachments[index].link) {
          console.log('有link')
        } else {
          this.attachments[index].link = {}
          this.attachments[index].link.title = ''
          this.attachments[index].link.picurl = ''
          this.attachments[index].link.source_material_id = ''
          this.attachments[index].link.rand_picurl = []
          this.attachments[index].link.rand_source_material_id = []
          this.attachments[index].link.desc = ''
          this.attachments[index].link.url = ''
          this.attachments[index].link.rand_title = 0
          this.attachments[index].link.title_options = []
          this.attachments[index].link.rand_desc = 0
          this.attachments[index].link.desc_options = []
          this.attachments[index].link.replace_link = 1
          // delete this.attachments[index].image
          // delete this.attachments[index].miniprogram
        }
      } else if (type === 'miniprogram') {
        if (this.attachments[index].miniprogram) {
          console.log('有miniprogram')
        } else {
          this.attachments[index].miniprogram = {}
          this.attachments[index].miniprogram.title = ''
          this.attachments[index].miniprogram.source_material_id = ''
          this.attachments[index].miniprogram.app_id = ''
          this.attachments[index].miniprogram.page = ''
          // this.attachments[index].miniprogram.pic_media_src = ''
          // delete this.attachments[index].image
          // delete this.attachments[index].link
        }
      } else {
        if (this.attachments[index].sp_miniprogram) {
          console.log('有sp_miniprogram')
        } else {
          this.attachments[index].sp_miniprogram = {}
          this.attachments[index].sp_miniprogram.app_id = ''
          this.attachments[index].sp_miniprogram.des_1 = ''
          this.attachments[index].sp_miniprogram.pagepath = ''
          this.attachments[index].sp_miniprogram.title = ''
          this.attachments[index].sp_miniprogram.weappiconurl = ''
          this.attachments[index].sp_miniprogram.miniprogram_no = ''
          this.attachments[index].sp_miniprogram.thumburl = ''
        }
      }
    },
    dialogtyper(type, index) {
      if (type === '') {
        this.$message.error('请选择要编辑的类型')
        return
      }
      if (type === null) {
        this.$message.error('请选择要编辑的类型')
        return
      }
      console.log('type', type)
      this.activetype = type
      this.activeindex = index
      if (type === 'image') {
        this.dialogVisibletwo = true
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.mychild.parentHandleclick('1')
        }, 100)
      } else if (type === 'link') {
        console.log(this.attachments[index].link.title)
        this.dialogVisibletu = true
        if (this.attachments[index].link.title === '') {
          setTimeout(() => {
            // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.tuwenview.send({})
          }, 100)
        } else {
          setTimeout(() => {
            // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.tuwenview.send(this.attachments[index].link)
          }, 100)
        }
      } else if (type === 'miniprogram') {
        this.dialogVisiblewechat = true
        if (this.attachments[index].miniprogram.title === '') {
          setTimeout(() => {
            // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.wecahtview.send(this.attachments[index].miniprogram, this.type, this.ids)
          }, 100)
        } else {
          setTimeout(() => {
            // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            console.log('this.attachments[index].miniprogram', this.attachments[index].miniprogram, this.ids)
            this.$refs.wecahtview.send(this.attachments[index].miniprogram, this.type, this.ids)
          }, 100)
        }
      } else {
        this.dialogVisiblewecaht = true
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.wechatview.send()
        }, 100)
      }
    },
    add() {
      this.attachments.push({
        msgtype: ''
      })
      this.newContent = this.tihuan.slice()
      this.newContent.unshift(this.content)

      console.log('this.newContent', this.newContent)
      this.scrollAttachmentListToBottom()
    },
    scrollAttachmentListToBottom() {
      const scroll = () => {
        const list = this.$refs.attachmentList
        const el = list && list.$el
        if (el) {
          el.scrollTop = el.scrollHeight
        }
      }
      this.$nextTick(() => {
        this.$nextTick(() => {
          requestAnimationFrame(scroll)
        })
      })
    },
    deleter(index) {
      this.attachments.splice(index, 1)
    },
    async onclick() {
      console.log('this.attachments', this.attachments)
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.rand_title === 1 && !(this.content || '').trim()) {
        this.$message.error('请先填写消息内容')
        return
      }
      if (this.attachments.length === 0) {
        if (!(this.content || '').trim()) {
          this.$message.error('内容和附件不能同时为空')
          return
        }
      }
      const msgtypebool = this.attachments.every((item, index, array) => {
        return item.msgtype
      })
      if (msgtypebool === false) {
        this.$message.error('请选择类型')
        return
      }
      // if (this.rand_title === 1 && this.content !== '') {
      //   if (this.title_options.length === 0) {
      //     this.$message.error(`请完善要编辑替换的内容`)
      //     return
      //   }
      //   for (let i = 0; i < this.title_options.length; i++) {
      //     if (this.title_options[i] === '') {
      //       this.$message.error(`请完善要编辑替换的内容`)
      //       return
      //     }
      //   }
      // }
      // if (this.rand_title === 1 && this.content !== '') {
      //   if (this.title_options.length === 0) {
      //     this.$message.error(`请完善要编辑替换的内容`)
      //     return
      //   }
      //   for (let i = 0; i < this.title_options.length; i++) {
      //     if (this.title_options[i] === '') {
      //       this.$message.error(`请完善要编辑替换的内容`)
      //       return
      //     }
      //   }
      // }
      if (this.title_options.length !== 0) {
        for (let i = 0; i < this.title_options.length; i++) {
          if (this.title_options[i] === '') {
            this.$message.error(`请完善要编辑替换的内容`)
            return
          }
        }
      }

      // for (let i = 0; i < this.attachments.length; i++) {
      //   if (this.attachments[i].msgtype) {
      //     this.$message.error(`请选择第${i + 1}条消息类型`)
      //     return
      //   }
      // }
      // const arrs = []
      // this.attachments.forEach((item) => {
      //   if (item.msgtype === 'miniprogram') {
      //     arrs.push({
      //       app_id: item.miniprogram.app_id,
      //       page: item.miniprogram.page,
      //       pic_media_src: item.miniprogram.pic_media_src,
      //       source_material_id: item.miniprogram.source_material_id,
      //       title: item.miniprogram.title
      //     })
      //   }
      // })
      // const routinetypebool = arrs.every((item, index, array) => {
      //   return item.app_id !== ''
      // })
      // if (routinetypebool === false) {
      //   this.$message.error('请完善要编辑的小程序附件')
      //   return
      // }

      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].msgtype === 'miniprogram') {
          if (this.attachments[i].miniprogram.app_id === '') {
            this.$message.error(`请完善要编辑的第${i + 1}条消息小程序附件`)
            return
          }
        }
      }
      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].msgtype === 'sp_miniprogram') {
          if (this.attachments[i].sp_miniprogram.app_id === '') {
            this.$message.error(`请完善要编辑的第${i + 1}条消息小程序附件`)
            return
          }
        }
      }

      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].msgtype === 'link') {
          if (this.attachments[i].link.title === '') {
            this.$message.error(`请完善要编辑的第${i + 1}条消息图文附件`)
            return
          }
          const covers = getLinkCovers(this.attachments[i].link)
          if (!covers.length || !covers.every(isCompleteLinkCover)) {
            this.$message.error(`请完善要编辑的第${i + 1}条消息图文封面`)
            return
          }
        }
      }

      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].msgtype === 'image') {
          if (this.attachments[i].image.pic_url === '') {
            this.$message.error(`请完善要编辑的第${i + 1}条消息图片附件`)
            return
          }
        }
      }
      console.log(' this.attachments', this.attachments)
      this.attachmentsarrs = []
      this.attachments.forEach((item, index) => {
        if (item.msgtype === 'miniprogram') {
          console.log(item.miniprogram, 'miniprogram-----------------------')
          this.attachmentsarrs.push({
            msgtype: 'miniprogram',
            miniprogram: item.miniprogram
          })
        }
        if (item.msgtype === 'link') {
          this.attachmentsarrs.push({
            msgtype: 'link',
            link: { ...item.link, ...getLinkCoverFields(getLinkCovers(item.link)) }
          })
        }
        if (item.msgtype === 'image') {
          this.attachmentsarrs.push({
            msgtype: 'image',
            image: item.image
          })
        }
        if (item.msgtype === 'sp_miniprogram') {
          this.attachmentsarrs.push({
            msgtype: 'sp_miniprogram',
            sp_miniprogram: item.sp_miniprogram
          })
        }
      })
      this.submitting = true
      try {
        if (this.type === 1 || this.type === 3) {
          if (this.content === '' && this.rand_title === 1) {
            await this.$confirm('随机内容为空是否提交, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning'
            })
            await spMessage({
              title: this.title,
              content: this.content,
              rand_title: this.rand_title,
              title_options: this.title_options,
              attachments: this.attachmentsarrs,
              push_method: this.push_method
            })
            this.messageload = true
            this.$router.go(-1)
          } else {
            const data = await spMessage({
              title: this.title,
              content: this.content,
              rand_title: this.rand_title,
              title_options: this.title_options,
              attachments: this.attachmentsarrs,
              push_method: this.push_method
            })
            this.messageload = true
            this.$router.go(-1)
            console.log('data', data)
          }
        } else {
          if (this.content === '' && this.rand_title === 1) {
            await this.$confirm('随机内容为空是否提交, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning'
            })
            await spMessagelistupdata({
              title: this.title,
              content: this.content,
              rand_title: this.rand_title,
              title_options: this.title_options,
              attachments: this.attachmentsarrs,
              sp_message_no: this.sp_message_no
            })
            this.messageload = true
            this.$router.go(-1)
          } else {
            const data = await spMessagelistupdata({
              title: this.title,
              content: this.content,
              rand_title: this.rand_title,
              title_options: this.title_options,
              attachments: this.attachmentsarrs,
              sp_message_no: this.sp_message_no
            })
            this.messageload = true
            this.$router.go(-1)
            console.log('data', data)
          }
        }
      } catch (e) {
        // 用户取消确认或请求失败
      } finally {
        this.submitting = false
      }
    },
    clickicon(img, key) {
      if (this.activetype === 'image') {
        this.dialogVisibletwo = false
        this.attachments[this.activeindex].image.source_material_id = key
        this.attachments[this.activeindex].image.pic_url = img
      }
    },
    callback(form, rand_title, title_options, rand_desc, desc_options, replace_link) {
      if (this.activetype === 'link') {
        console.log('111')
        this.dialogVisibletu = false
        this.$set(this.attachments[this.activeindex], 'link', {
          ...this.attachments[this.activeindex].link,
          ...getLinkCoverFields(getLinkCovers({ ...form, picurl: form.testsrc })),
          title: form.title,
          desc: form.description,
          url: form.url,
          rand_title,
          title_options,
          rand_desc,
          desc_options,
          replace_link
        })
      }
    },
    callwechat(form) {
      if (this.activetype === 'miniprogram') {
        this.dialogVisiblewechat = false
        console.log('form---', form)
        // this.attachments[this.activeindex].miniprogram.title = form.name
        // this.attachments[this.activeindex].miniprogram.source_material_id = form.sourceMaterialId
        // this.attachments[this.activeindex].miniprogram.app_id = form.app_id
        // this.attachments[this.activeindex].miniprogram.page = form.link
        // this.attachments[this.activeindex].miniprogram.pic_media_src = form.programimg
        this.attachments[this.activeindex].miniprogram.app_id = form.app_id
        this.attachments[this.activeindex].miniprogram.des_1 = form.des_1
        // this.attachments[this.activeindex].miniprogram.pagepath = form.pagepath
        this.attachments[this.activeindex].miniprogram.page = form.pagepath
        this.attachments[this.activeindex].miniprogram.title = form.title
        this.attachments[this.activeindex].miniprogram.weappiconurl = form.weappiconurl
        this.attachments[this.activeindex].miniprogram.miniprogram_no = form.miniprogram_no
        this.attachments[this.activeindex].miniprogram.thumburl = form.thumburl
        this.attachments[this.activeindex].miniprogram.miniprogram_title = form.miniprogram_title
        this.attachments[this.activeindex].miniprogram.source_material_id = form.source_material_id
        this.attachments[this.activeindex].miniprogram.recent_reading_page = form.recent_reading_page
      }
    },
    wechatcallback(form) {
      if (this.activetype === 'sp_miniprogram') {
        this.dialogVisiblewecaht = false
        console.log('form', form)
        this.attachments[this.activeindex].sp_miniprogram.app_id = form.app_id
        this.attachments[this.activeindex].sp_miniprogram.des_1 = form.des_1
        this.attachments[this.activeindex].sp_miniprogram.pagepath = form.pagepath
        this.attachments[this.activeindex].sp_miniprogram.title = form.title
        this.attachments[this.activeindex].sp_miniprogram.weappiconurl = form.weappiconurl
        this.attachments[this.activeindex].sp_miniprogram.miniprogram_no = form.miniprogram_no
        this.attachments[this.activeindex].sp_miniprogram.thumburl = form.thumburl
        this.attachments[this.activeindex].sp_miniprogram.source_material_id = form.source_material_id
      }
    },
    opens(type, item) {
      this.getmptypeslist()
      this.type = type
      if (type === 1) {
        console.log('新增')
        // this.attachments = item.attachments
      } else {
        console.log(item)
        this.ids = item.sp_message_no
        this.detail()
      }
    },
    async detail() {
      this.loading = true
      const data = await sprEnterprise({
        sp_message_no: this.ids
      })
      // eslint-disable-next-line eqeqeq
      const bool = JSON.stringify(data.data) == '{}'
      console.log(bool) // 返回true
      // eslint-disable-next-line eqeqeq
      if (bool == false) {
        this.attachments = []
        this.title = data.data.title
        this.content = data.data.content === null ? '' : data.data.content
        this.rand_title = data.data.rand_title
        this.title_options = data.data.title_options
        this.attachments = data.data.attachments
        this.sp_message_no = data.data.sp_message_no
        this.push_method = data.data.push_method
        this.loading = false
        console.log('data', data)
      } else {
        this.loading = false
        this.$message.error('内容格式错误')
      }
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = data.data.types
    },
    find(id) {
      console.log('id', id)
      const indexs = this.programtype.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.mini_program_type == id
      })
      if (indexs === -1) {
        return ''
      } else {
        return this.programtype[indexs].type_name
      }
    },
    sendcahaer(val) {
      if (val === 1) {
        console.log('attachments1', this.attachments)
        this.attachments.forEach(item => {
          if (item.msgtype !== '') {
            item.msgtype = ''
          }
        })
      } else {
        console.log('attachments2', this.attachments)
        this.attachments.forEach(item => {
          if (item.msgtype !== '') {
            item.msgtype = ''
          }
        })
      }
    },
    changewr(item, index) {
      console.log(item)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      if (item.link.rand_title === 1) {
        getMultiTitles({
          text: item.link.title
        }).then(res => {
          console.log('111', res)
          item.link.title_options = res.data
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        })
      } else {
        item.link.title_options = []
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    },
    changewrr(item) {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      if (item.link.rand_desc === 1) {
        getMultiTitles({
          text: item.link.desc
        }).then(res => {
          console.log('222', res)
          item.link.desc_options = res.data
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        })
      } else {
        item.link.desc_options = []
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    },
    changewrrr() {
      return this.contneer()
    },
    async contneer() {
      const text = this.content
      if (this.rand_title !== 1) {
        this.title_options = []
        return
      }
      if (!(text || '').trim()) {
        this.title_options = []
        this.$message.error('请先填写消息内容')
        return
      }
      const options = await getRandomTextOptions(text)
      // 输入或随机选项已变化时，不让旧请求覆盖当前内容。
      if (this.rand_title === 1 && this.content === text) {
        this.title_options = options
      }
    },
    deater(index) {
      this.title_options.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.moment-form-page {
  min-height: calc(100vh - 84px);
  padding: 20px 24px 80px;
  background: #f0f2f5;
  box-sizing: border-box;
}

/* 卡片 */
.form-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.form-card ::v-deep .el-card__header {
  padding: 14px 20px;
  background: #fafbfc;
  border-bottom: 1px solid #ebeef5;
}

.form-card ::v-deep .el-card__body {
  padding: 24px 20px 8px;
}

.card-header {
  display: flex;
  align-items: center;
}

.card-header--between {
}

.card-header__group {
  display: flex;
  align-items: center;
}

.card-header__icon {
  margin-right: 8px;
  font-size: 16px;
  color: #3a71a8;
}

.card-header__text {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.card-header__tag {
  margin-left: 10px;
}

/* 表单 */
.base-form {
  max-width: 920px;
}

.form-input--wide {
  width: 100%;
  max-width: 760px;
}

.form-input--medium {
  width: 240px;
}

/* 随机内容替换列表 */
.title-options-list {
  max-height: 270px;
  overflow-y: auto;
  padding-right: 4px;
}

.title-options-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.title-options-item:last-child {
  margin-bottom: 0;
}

/* 附件提示 */
.attachment-tip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
  padding: 8px 12px;
  font-size: 13px;
  color: #e6a23c;
  background: #fdf6ec;
  border-radius: 4px;
  border: 1px solid #faecd8;
}

.attachment-tip .el-icon-info {
  font-size: 14px;
}

/* 空状态 */
.attachment-empty {
  padding: 48px 20px;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
}

.attachment-empty__icon {
  font-size: 48px;
  color: #c0c4cc;
}

.attachment-empty__text {
  margin: 12px 0 4px;
  font-size: 14px;
  color: #606266;
}

.attachment-empty__hint {
  margin: 0;
  font-size: 12px;
  color: #909399;
}

/* 附件列表 */
.attachment-list {
  max-height: 520px;
  overflow-y: auto;
  padding-right: 4px;
}

.attachment-item {
  margin-bottom: 16px;
  padding: 16px;
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  transition: box-shadow 0.2s;
  cursor: grab;
}

.attachment-item:active {
  cursor: grabbing;
}

.attachment-item:last-child {
  margin-bottom: 0;
}

.attachment-item:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.attachment-item--ghost {
  opacity: 0.4;
  background: #edf3ff;
  border-color: #2563eb;
}

.attachment-item--chosen {
  border-color: #2563eb;
}

.attachment-item__drag-handle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  cursor: grab;
  user-select: none;
  touch-action: none;
}

.attachment-item__drag-handle:active {
  cursor: grabbing;
}

.attachment-item__drag-handle .el-icon-rank {
  color: #74839a;
  font-size: 16px;
}

.attachment-item__drag-hint {
  margin-left: auto;
  color: #74839a;
  font-size: 12px;
  white-space: nowrap;
}

.attachment-item__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.attachment-item__index {
  font-size: 14px;
  font-weight: 600;
  color: #3a71a8;
  min-width: 56px;
}

.attachment-item__actions {
  display: flex;
  gap: 8px;
}

.attachment-item__body {
  padding-left: 4px;
}

/* 图片上传/预览 */
.image-uploader,
.image-preview {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
}

.image-uploader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #c0c4cc;
  background: #fff;
  transition: border-color 0.2s, color 0.2s;
}

.image-uploader:hover {
  border-color: #3a71a8;
  color: #3a71a8;
}

.image-uploader__icon {
  font-size: 28px;
  color: #c0c4cc;
  margin-bottom: 6px;
}

.image-uploader:hover .image-uploader__icon {
  color: #3a71a8;
}

.image-uploader__text {
  font-size: 12px;
  color: #909399;
}

.image-preview {
  position: relative;
  border: 1px solid #ebeef5;
  background: #fff;
}

.image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-preview__mask {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.2s;
}

.image-preview:hover .image-preview__mask {
  opacity: 1;
}

.image-preview__mask .el-icon-edit {
  font-size: 20px;
}

/* 链接预览 */
.link-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.link-preview {
  max-width: 280px;
  padding: 12px;
  background: #fff;
  border: 1px solid #67c23a;
  border-radius: 8px;
  cursor: pointer;
  transition: box-shadow 0.2s;
}

.link-preview:hover {
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.2);
}

.link-preview__title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 10px;
}

.link-preview__content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.link-preview__cover-count {
  margin-top: 6px;
  text-align: right;
  font-size: 12px;
  color: #74839a;
}

.link-preview__desc {
  flex: 1;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 54px;
}

.link-preview__thumb {
  width: 50px;
  height: 50px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 4px;
}

.link-random-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.link-random-tags__label {
  font-size: 13px;
  color: #606266;
  flex-shrink: 0;
}

.link-random-tags__tag {
  margin: 0;
}

.link-placeholder,
.type-placeholder {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  font-size: 13px;
  color: #909399;
  background: #fff;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.link-placeholder:hover {
  border-color: #3a71a8;
  color: #3a71a8;
}

.type-placeholder {
  cursor: default;
  color: #e6a23c;
  border-color: #faecd8;
  background: #fdf6ec;
}

/* 小程序卡片 */
.mincard {
  width: 240px;
  padding: 12px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  box-sizing: border-box;
}

.mincard:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.mincard__header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.mincard__icon {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mincard__desc {
  font-size: 12px;
  color: #909399;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mincard__title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mincard__type {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
}

.mincard__thumb {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 8px;
}

.mincard__footer {
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
}

/* 底部操作 */
.form-card--actions {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - 210px);
  margin-bottom: 0;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-bottom: none;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  transition: width 0.28s;
}

.form-card--actions ::v-deep .el-card__body {
  padding: 16px 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

@media (max-width: 768px) {
  .moment-form-page {
    padding: 16px 16px 80px;
  }

  .base-form {
    max-width: 100%;
  }

  .form-input--wide,
  .form-input--medium {
    max-width: 100%;
    width: 100% !important;
  }

  .attachment-item__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .attachment-item__actions {
    margin-left: 0;
    width: 100%;
  }

  .title-options-item {
    flex-direction: column;
  }
}
</style>

<style lang="scss">
#app .hideSidebar .moment-form-page .form-card--actions {
  width: calc(100% - 54px);
}

#app .mobile .moment-form-page .form-card--actions {
  width: 100%;
}
</style>
